import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import PropTypes from "prop-types";

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If no specific roles are required, allow access
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user has the required role
  if (!allowedRoles.includes(user.role)) {
    // Redirect to the appropriate dashboard based on user's role
    if (user.role === "admin") {
      return <Navigate to="/admin/overview" replace />;
    } else if (user.role === "chapter_head") {
      return <Navigate to="/chapter/overview" replace />;
    } else if (user.role === "follow_up_user") {
      return <Navigate to="/follow-up/overview" replace />;
    } else {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};
